import React from 'react'
import { Typography, Icon } from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.errorView.contrastText,
  },
  errorIcon: {
    fontSize: '86px',
  },
}))

const EmptyStateView = (props) => {
  const { icon, title, subtitle, children, ...rest } = props
  const classes = useStyles()

  return (
    <div
      className={clsx(classes.root, 'flex flex-col items-center py-64')}
      {...rest}
    >
      <Icon className={clsx(classes.errorIcon, 'my-16')}>
        {icon || 'report_problem'}
      </Icon>
      <Typography variant="subtitle1">{title}</Typography>
      {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
      <div className="mt-24">{children}</div>
    </div>
  )
}

EmptyStateView.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object]),
  subtitle: PropTypes.string,
  children: PropTypes.element,
}

export default EmptyStateView
